import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-slate-950 text-slate-300 py-12 border-t border-slate-800">
      <div className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div className="space-y-4 col-span-1 md:col-span-2">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-white p-1">
<picture>
                <source srcSet="https://wsrv.nl/?url=https%3A%2F%2Fvibe.filesafe.space%2F1776204073728798439%2Fattachments%2Fc60387b0-6ed4-41b6-bd27-ec59d975e577.jpg&output=webp" type="image/webp" />
                <img 
                  src="https://vibe.filesafe.space/1776204073728798439/attachments/c60387b0-6ed4-41b6-bd27-ec59d975e577.jpg" 
                  alt="Missed Call Rescue Logo" 
                  className="h-full w-full object-contain rounded-full"
                  loading="lazy"
                  decoding="async"
                  width={40}
                  height={40}
                />
              </picture>
            </div>
            <div className="flex flex-col">
              <span className="text-lg font-bold leading-tight tracking-tight text-white">Missed Call</span>
              <span className="text-xs font-semibold tracking-widest text-emerald-400">RESCUE</span>
            </div>
          </div>
          <p className="text-sm text-slate-400 max-w-sm">
            Based in Edmonton, Alberta, Missed Call Rescue provides automated text back and conversational Ai systems and Ai solutions tailored for small business customer care. Don't risk losing a client—turn missed calls into booked appointments with our automatic booking system and streamlined workflows.
          </p>
        </div>

        <div className="space-y-4">
          <h3 className="text-white font-semibold text-lg">Quick Links</h3>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-emerald-400 transition-colors">Home</Link></li>
            <li><Link to="/features" className="hover:text-emerald-400 transition-colors">Features</Link></li>
            <li><Link to="/serviced-areas" className="hover:text-emerald-400 transition-colors">Serviced Areas</Link></li>
            <li><Link to="/contact" className="hover:text-emerald-400 transition-colors">Contact Us</Link></li>
          </ul>
        </div>

        <div className="space-y-4">
          <h3 className="text-white font-semibold text-lg">Contact</h3>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <Phone className="h-5 w-5 text-emerald-400 shrink-0 mt-1" />
              <span className="flex flex-col">
                <span>Toll-free: <a href="tel:1-855-780-3522" className="hover:text-white transition-colors">1-855-780-3522</a></span>
                <span>Local: <a href="tel:780-237-6933" className="hover:text-white transition-colors">780-237-6933</a></span>
              </span>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="h-5 w-5 text-emerald-400 shrink-0" />
              <a href="mailto:missedcallrescuecanada@gmail.com" className="hover:text-white transition-colors">missedcallrescuecanada@gmail.com</a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="h-5 w-5 text-emerald-400 shrink-0" />
              <span>Edmonton, Alberta<br/>Canada T5L2C2</span>
            </li>
          </ul>
        </div>
      </div>
      
      <div className="container mx-auto px-4 mt-12 pt-8 border-t border-slate-800 text-sm text-slate-500 flex flex-col md:flex-row justify-between items-center gap-4">
        <p>&copy; {new Date().getFullYear()} Missed Call Rescue. All rights reserved.</p>
        <div className="flex gap-4">
          <Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link>
          <Link to="/terms-of-service" className="hover:text-white transition-colors">Terms & Conditions</Link>
        </div>
      </div>
    </footer>
  );
};
